"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var required_1 = __importDefault(require("./required"));
function requiredIf(value, options, params) {
    var isValid = true;
    var isRequired = options.condition(params === null || params === void 0 ? void 0 : params.entity);
    if (isRequired) {
        isValid = (0, required_1.default)(value, true);
    }
    return isValid;
}
exports.default = requiredIf;
